'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Seq } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAvailableDates as getAvailableDatesSelector, isSelectedDateAvailable as getIsSelectedDateAvailable } from 'MeetingsLib/selectors/AvailabilitySelectors';
import { getIsFetchingPublicAvailability, getIsFetchingOwnerPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
export default (WrappedComponent => {
  class EnsureAvailableDate extends Component {
    componentDidMount() {
      const {
        compact,
        availableDateOptions,
        isSelectedDateAvailable,
        setEventDate
      } = this.props;

      if (!compact && !isSelectedDateAvailable) {
        setEventDate(availableDateOptions.min());
      }
    }

    componentDidUpdate(prevProps) {
      const {
        isFetchingPublicAvailability: publicAvailabilityWasLoading,
        isFetchingPublicOwnerAvailability: ownerAvailabilityWasLoading
      } = prevProps;
      const {
        isFetchingPublicAvailability: publicAvailabilityLoading,
        isFetchingPublicOwnerAvailability: ownerAvailabilityLoading,
        isSelectedDateAvailable,
        availableDateOptions,
        setEventDate,
        compact
      } = this.props;
      const publicWasLoading = publicAvailabilityWasLoading && !publicAvailabilityLoading;
      const publicOwnerWasLoading = ownerAvailabilityWasLoading && !ownerAvailabilityLoading;

      if (publicWasLoading || publicOwnerWasLoading) {
        if (!compact && !isSelectedDateAvailable) {
          setEventDate(availableDateOptions.min());
        }
      }
    }

    render() {
      const _this$props = this.props,
            otherProps = _objectWithoutPropertiesLoose(_this$props, ["isSelectedDateAvailable", "availableDateOptions", "isFetchingPublicAvailability", "isFetchingPublicOwnerAvailability"]);

      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, otherProps));
    }

  }

  EnsureAvailableDate.displayName = `EnsureAvailableDate(${WrappedComponent.displayName})`;
  EnsureAvailableDate.propTypes = {
    isSelectedDateAvailable: PropTypes.bool,
    compact: PropTypes.bool,
    setEventDate: PropTypes.func.isRequired,
    availableDateOptions: PropTypes.instanceOf(Seq).isRequired,
    isFetchingPublicAvailability: PropTypes.bool.isRequired,
    isFetchingPublicOwnerAvailability: PropTypes.bool.isRequired
  };
  return connect(state => ({
    isSelectedDateAvailable: getIsSelectedDateAvailable(state),
    availableDateOptions: getAvailableDatesSelector(state),
    isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
    isFetchingPublicOwnerAvailability: getIsFetchingOwnerPublicAvailability(state)
  }))(EnsureAvailableDate);
});